/* eslint-disable react/jsx-indent */
import React from 'react';
import PropTypes from 'prop-types';

import TrackedClick from '../../../Analytics/TrackedClick';
import Img from '../../../Img';
import styles from './GlobalSearchNavigation.scss';
import { getClickAttrs } from '../../../Analytics/gtag';

const GlobalSearchNavItem = (props) => {
	const { onClick, label, entityType, testId } = props;

	const handleOnClick = () => {
		onClick();
	};

	return (
        <TrackedClick
            eventName="Global Search Category Clicked"
            label={label}
            traits={{ entityType }}
        >
            <button
                className={styles.navItem}
                onClick={handleOnClick}
                type="button"
                {...getClickAttrs({
                    category: 'Global Search Category',
                    context: label,
                    location: 'Global search CTA',
                    testid: testId,
                })}
            >
                {label}
                <Img
                    src="/img/right-chevron.svg"
                    alt="search menu item chevron"
                />
            </button>
        </TrackedClick>
	);
};

GlobalSearchNavItem.propTypes = {
	onClick: PropTypes.func.isRequired,
	label: PropTypes.string.isRequired,
	entityType: PropTypes.string.isRequired,
	testId: PropTypes.string.isRequired,
};

export default GlobalSearchNavItem;
